import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { PageHeader } from '../components/common'
import SessionSchedulingCalendar from '../components/sessions/SessionSchedulingCalendar'

const ScheduleRemainingSessions = () => {
  const history = useHistory()
  const location = useLocation()
  const coachDetails = location.state?.coachDetails

  const renderHelmet = () => (
    <Helmet>
      <title>{'Schedule More Sessions | Abroad'}</title>
      <meta name='title' content={'Schedule More Sessions | Abroad'}></meta>
      <meta
        property='og:title'
        content={'Schedule More Sessions | Abroad'}></meta>
      <meta
        property='twitter:title'
        content={'Schedule More Sessions | Abroad'}></meta>
      <link
        rel='canonical'
        href={`${process.env.REACT_APP_DOMAIN}/coaching/sessions/schedule-remaining`}></link>
      <meta
        property='og:url'
        content={`${process.env.REACT_APP_DOMAIN}/coaching/sessions/schedule-remaining`}></meta>
      <meta
        property='twitter:url'
        content={`${process.env.REACT_APP_DOMAIN}/coaching/sessions/schedule-remaining`}></meta>
    </Helmet>
  )

  const handleScheduleSuccess = (event) => {
    history.push('/coaching/sessions', {
      scheduledEvent: event,
    })
  }

  return (
    <>
      {renderHelmet()}
      <PageHeader
        title='Sessions'
        version='small'
        backArrowAction={() => history.push('/coaching/sessions')}
        showBackArrow={true}
      />
      <SessionSchedulingCalendar
        schedulingType={
          location.state?.useScheduleAll ? 'schedule-all' : 'remaining'
        }
        coachDetails={coachDetails}
        allowMultipleSelection={location.state?.useScheduleAll || false}
        onScheduleSuccess={handleScheduleSuccess}
      />
    </>
  )
}

export default ScheduleRemainingSessions
